import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureDepositsAccountSummary(props) {
    return <AccountSummaryPage />
}